import React from "react";

import { comment } from "@planzone/dto";
import { Props } from "./types";
import { Comment } from "./comment";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <ul className={styles.feed}>
      {[comment, comment, comment, comment].reverse().map((comment, index) => (
        <li key={index} className={styles.comment}>
          <Comment />
        </li>
      ))}
    </ul>
  );
}

export { Loader };
